<template>
    <form @submit.prevent="submit">
        <v-row>
            <v-col>
                {{ $t('indicators.indicators_wizard.body.title') }} :
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="3">
                <v-text-field class='input-text input-text--text-field' hide-details="auto" outlined dense v-model="title"></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                {{ $t('indicators.indicators_wizard.body.academic_period') }} :
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="2">
                <v-text-field class='input-text input-text--text-field' hide-details="auto" outlined dense v-model="academic_period"></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                {{ $t('indicators.indicators_wizard.body.data_origin') }} :
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <indicators-data-origin-table/>
            </v-col>
        </v-row>
    </form>
</template>
<script>
import IndicatorsDataOriginTable from "./IndicatorsDataOriginTable";

export default {
    name: "IndicatorWizardStep1",

    components: {IndicatorsDataOriginTable},

    data() {
        return {
            indicatorWizardStep: 1,
            title: "Indicadores 2021-2022",
            academic_period: "2021-2022",
        }
    },

    methods: {
        submit() {
            console.log("two-factor.login");            
        },
    },
}
</script>

<style scoped>

</style>